import { render, staticRenderFns } from "./Inventorya.vue?vue&type=template&id=2fcd7eb4&scoped=true&"
import script from "./Inventorya.vue?vue&type=script&lang=js&"
export * from "./Inventorya.vue?vue&type=script&lang=js&"
import style0 from "./Inventorya.vue?vue&type=style&index=0&id=2fcd7eb4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fcd7eb4",
  null
  
)

export default component.exports